module.exports = __webpack_public_path__ + "img/tjx_d_18.be674b4a.png";